import { render, staticRenderFns } from "./PregledDokumenta.vue?vue&type=template&id=175f256e&scoped=true&"
import script from "./PregledDokumenta.vue?vue&type=script&lang=ts&"
export * from "./PregledDokumenta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f256e",
  null
  
)

export default component.exports